import { Link, Outlet } from 'react-router';
import { Logo } from '@/components/Logo';
import { Button } from '@/components/ui';
import { useSession } from '@/features/auth';
import { CONTACT_EMAIL } from '@/lib/contact';
import { useStartHref } from '../useStartHref';

/** Landing header (72px) and footer; also used by the legal pages. */
export function MarketingLayout() {
  const { status, openSignIn } = useSession();
  const startHref = useStartHref();
  const signedIn = status === 'authenticated';

  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-surface focus:px-4 focus:py-2"
      >
        Skip to content
      </a>
      <header className="flex h-[72px] items-center justify-between border-b border-line px-4 md:px-8 xl:px-20">
        <Logo />
        <nav aria-label="Main" className="flex items-center gap-8 text-body-app">
          <Link to="/#tracks" className="hidden text-ink no-underline hover:text-accent md:inline">
            Tracks
          </Link>
          <Link to="/#how" className="hidden text-ink no-underline hover:text-accent md:inline">
            How it works
          </Link>
          {signedIn ? (
            <Link to="/learn" className="hidden text-ink no-underline hover:text-accent md:inline">
              Dashboard
            </Link>
          ) : (
            <button
              type="button"
              onClick={() => openSignIn({ returnTo: '/learn' })}
              className="hidden min-h-11 cursor-pointer border-0 bg-transparent p-0 text-body-app text-ink hover:text-accent md:inline"
            >
              Sign in
            </button>
          )}
          <Button to={startHref} variant="dark">
            {signedIn ? 'Continue' : 'Start coding'}
          </Button>
        </nav>
      </header>
      <div id="content" className="flex flex-1 flex-col">
        <Outlet />
      </div>
      <footer className="flex flex-col gap-3 border-t border-line px-4 py-6 text-sm text-ink-muted md:flex-row md:justify-between md:px-8 xl:px-20">
        <span>devlearn · built for developers who learn by doing</span>
        <span className="flex gap-6">
          <Link to="/privacy" className="text-ink-muted">
            Privacy
          </Link>
          <Link to="/terms" className="text-ink-muted">
            Terms
          </Link>
          {CONTACT_EMAIL && (
            <a href={`mailto:${CONTACT_EMAIL}`} className="text-ink-muted">
              Contact
            </a>
          )}
        </span>
      </footer>
    </div>
  );
}
